import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { v4SearchDataResponse, v4DataFetchParams, v4SearchParams } from './types';

const fetchV4SearchData = async (params: v4DataFetchParams) => {
  const response = await api.post<v4SearchDataResponse>('/web/v4/search', params, {
    params: { version: params.ver, system_model: params.system_model },
  });
  return response.data;
};

/** Only v4 releases serve this endpoint, so the query stays idle on 3.x whatever the caller asks for. */
const useV4SearchData = (
  params: v4SearchParams,
  options?: Omit<UseQueryOptions<v4SearchDataResponse, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const { ver, system_model } = useVersionInfo();
  return useQuery<v4SearchDataResponse, AxiosError>({
    queryKey: ['searchV4', ver, system_model, params],
    queryFn: () => fetchV4SearchData({ ...params, ver, system_model }),
    ...options,
    enabled: isV4Release(ver) && (options?.enabled ?? true),
  });
};

export default useV4SearchData;
